import BaseButton from "components/base/baseButton";
import styled from "styled-components";
import headingBG from "assets/images/png/createProject/heading-bg.png";

import { Input, InputNumber, Select, Steps, Upload, Modal } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { CommonFlexRow } from "pages/OrganizationPage/OrganizationPage.style";
import { CommonFlexColumn } from "pages/OrganizationPage/Transaction/transaction.style";
import PrimaryButton from "components/base/primaryButton";

const { Option } = Select;

export const ProjectStep = styled(Steps)`
  max-width: 861px;
  margin-top: 18px;
  margin-inline: auto;

  .ant-steps-item-icon {
    border: none;
  }

  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon {
    background: #c3c6cf;
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: #7e00fd;
    border: none;
  }

  .ant-steps-item:nth-last-child(2) {
    &.ant-steps-item-finish
      > .ant-steps-item-container
      > .ant-steps-item-tail:after {
      background: linear-gradient(
        90deg,
        #7e00fd 27.03%,
        #7e00fd 50.83%,
        #00de8c 102.5%
      );
    }
  }

  .ant-steps-item:not(:last-child) {
    &.ant-steps-item-process
      > .ant-steps-item-container
      > .ant-steps-item-icon {
      background: #7e00fd;

      svg path {
        fill: #fff;
        fill-opacity: 1;
      }
    }

    &.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
      svg path {
        fill: #fff;
        fill-opacity: 1;
      }
    }
  }

  .ant-steps-item:last-child {
    &.ant-steps-item-process
      > .ant-steps-item-container
      > .ant-steps-item-icon {
      background: #00de8c;
    }
  }

  .ant-steps-item-tail:after {
    height: 2px;
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-tail:after {
    background-color: #c3c6cf;
  }

  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-tail:after {
    background-color: #c3c6cf;
  }

  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail:after {
    background: #7e00fd;
  }

  .ant-steps-item-icon .ant-steps-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-steps-item-icon {
    padding: 8px;
  }

  .ant-steps-item-tail {
    top: 20px;
    margin-left: 66px;
  }

  &.ant-steps-label-vertical .ant-steps-item-content {
    margin-left: 8px;
  }

  .ant-steps-item-title {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 115%;
    text-align: center;
    color: #080a25;
  }

  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #080a25;
  }

  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #080a2580;
  }
`;

export const ProjectWrapper = styled.div``;

export const CreateProjectTitle = styled.h1`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 130%;
  letter-spacing: -0.04em;
  color: #080f6c;
  margin-bottom: 0;
  max-width: 292px;
`;

export const Heading = styled.div`
  padding: 0 99px;
  background: linear-gradient(
    90deg,
    rgba(208, 234, 255, 0.58) 0%,
    rgba(248, 233, 245, 0.75) 40%,
    rgba(246, 244, 241, 0.83) 60%,
    rgba(233, 247, 251, 0.92) 81%,
    rgba(233, 247, 250, 0.92) 100%
  );
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:before {
    content: "";
    position: absolute;
    bottom: -82px;
    left: 0;
    width: 100%;
    height: 42%;
    background: linear-gradient(
      90deg,
      rgba(208, 234, 255, 1) 0%,
      rgba(248, 233, 245, 1) 40%,
      rgba(246, 244, 241, 1) 60%,
      rgba(233, 247, 251, 1) 81%,
      rgba(233, 247, 250, 1) 100%
    );
    filter: blur(20px);
  }
`;

export const CoverImage = styled.img`
  /* max-width: 250px;
  aspect-ratio: 1 / 1;
  object-fit: cover; */
  width: 376px;
  aspect-ratio: 2.9375;
`;

export const StepIndication = styled.span`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: #7e00fd;
`;

export const TitleWrapper = styled(CommonFlexRow)`
  margin-bottom: 32px;
`;

export const ProjectTitle = styled.h3`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.02em;
  color: #080a25;
  margin-block: 24px;
`;

export const Title = styled.div`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 120%;
  letter-spacing: -0.02em;
  color: #080f6c;
  margin: 1.875rem auto 1.25rem;
`;

export const Container = styled.div`
  position: relative;
  background: #fff;
  border-radius: 24px 24px 0 0;
  display: flex;
  flex-direction: column;
  max-width: 73.125rem;
  max-width: 1170px;
  margin: auto;
  padding: 0rem 3.125rem;
`;

export const Left = styled.div`
  width: 12.5rem;
  border-right: 0.0625rem solid rgba(41, 46, 115, 0.12);
  height: 100%;
`;
export const Right = styled.div`
  padding-left: 3rem;
  padding-bottom: 6.25rem;
`;
export const AvatarContainer = styled.div`
  width: 9.375rem;
  text-align: center;
  padding-top: 35px;
  .ant-form-item {
    margin-bottom: 0;
  }
`;
export const StyledInput = styled(Input)`
  max-width: 100%;
  border: 0.0625rem solid rgba(41, 46, 115, 0.12);
  border-radius: 0.25rem;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #080f6c;
  height: 2.25rem;
  padding: 0.625rem;
  &::placeholder {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: rgba(41, 46, 115, 0.42);
  }
`;

export const StyledInputNumber = styled(InputNumber)`
  max-width: 100%;
  border: 0.0625rem solid rgba(41, 46, 115, 0.12);
  border-radius: 0.25rem;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #080f6c;
  height: 2.25rem;
  padding: 0.625rem;
  width: 100%;
  padding-left: 0;

  &::placeholder {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: rgba(41, 46, 115, 0.42);
  }

  .ant-input-number-input-wrap {
    flex-grow: 1;
  }
`;
export const StyledTextArea = styled(Input.TextArea)`
  width: 100%;
  border: 0.0625rem solid rgba(41, 46, 115, 0.12);
  border-radius: 0.25rem;
  height: 8.125rem !important;
  padding: 0.625rem;

  &::placeholder {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: rgba(41, 46, 115, 0.42);
    padding-top: 6px;
  }
`;

export const StyledFormItem = styled(FormItem)`
  label {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 100%;
    letter-spacing: -0.01em;
    color: #080f6c;
  }
  .ant-form-item-label {
    padding-bottom: 0.625rem;
  }
  .upload-image {
    .ant-upload {
      width: 100%;
      height: unset;
    }
    // img {
    //   height: 100%;
    //   width: auto;
    //   max-width: 100%;
    // }
  }
`;

export const BigLabel = styled.div`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 120%;
  letter-spacing: -0.02em;
  color: #080f6c;
`;

export const LabelDescription = styled.div`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 120%;
  color: rgba(41, 46, 115, 0.82);
  opacity: 0.6;
`;

export const StyledUpload = styled(Upload)`
  width: auto;

  .ant-upload-list {
    width: 100%;
    .ant-upload-list-picture-card-container {
      display: block;
      margin: auto;
    }
    .ant-upload-list-picture-card-container {
      width: 18.75rem;
      height: auto;
      margin-bottom: 1rem;
    }
    .ant-upload-list-item {
      border: 0.0625rem solid rgba(41, 46, 115, 0.22);
    }
  }
  .ant-upload {
    width: 100%;
    height: 8rem;
    margin-bottom: 0;
    margin-right: 0;

    &.ant-upload-select-picture-card {
      border-radius: 8px;
      border: none;
      // padding: 22px 60px;
      background: radial-gradient(
        100% 445.32% at 0% 100%,
        rgba(126, 0, 253, 0.07) 0%,
        rgba(185, 61, 243, 0.07) 42.35%,
        rgba(165, 75, 244, 0.07) 57.95%,
        rgba(0, 191, 251, 0.07) 100%
      );
    }
  }
  &.noBorder {
    .ant-upload-select-picture-card {
      border: none;
    }
  }
`;

export const AvatarUpload = styled(Upload)`
  .ant-upload-list {
    width: 9.375rem;
    margin-top: 1.875rem;
    margin-bottom: 0.625rem;
    .ant-upload-list-picture-card-container {
      display: block;
      margin: auto;
    }
    .ant-upload-list-picture-card-container {
      width: 9.375rem;
      height: auto;
      margin-bottom: 1rem;
    }
    .ant-upload-list-item {
      border: 0.0625rem solid rgba(41, 46, 115, 0.22);
    }
  }
  .ant-upload {
    width: 9.375rem;
    height: 9.375rem;
    &.ant-upload-select-picture-card {
      border-radius: 0.25rem;
      background-image: url(${headingBG});
      background-size: cover;
      border: 0.0625rem solid rgba(41, 46, 115, 0.07);
    }
  }
`;
export const NoFileText = styled.span`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 100%;
  color: rgba(41, 46, 115, 0.82);
  margin-left: 0.9rem;
`;
export const SocialFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  grid-gap: 0 1.25rem;
  margin-top: 2rem;
`;

export const LabelWithIcon = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-right: 0.3rem;
  }
`;

export const StyledSelect = styled(Select)`
  max-width: 100%;
  width: 100%;
  border: 0.0625rem solid rgba(41, 46, 115, 0.12);
  border-radius: 0.25rem;
  height: 2.25rem;
  &:not(.ant-select-customize-input) .ant-select-selector {
    border: none !important;
  }
  svg {
    margin-right: 0.3rem;
  }
  .ant-select-selection-placeholder {
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 100%;
    display: flex;
    align-items: center;
    color: #080f6c;

    margin-left: 0.5rem;
  }
  .ant-select-selection-item {
    padding-top: 0.1875rem !important;
  }
  .ant-select-arrow {
    svg {
      margin-right: 0;
    }
  }
  &.ant-select-open {
    border: 1px solid #7e00fd;
    border-radius: 4px 4px 0px 0px;
    .ant-select-arrow {
      transform: rotate(180deg);
      path {
        stroke: #7e00fd;
      }
    }
  }
`;
export const StyledSelectUser = styled(StyledSelect)`
  &.ant-select-open {
    .ant-select-arrow {
      transform: rotate(0);
    }
  }
`;

export const StyledOption = styled(Option)`
  /* background: red !important; */
`;

export const TokenSelectText = styled.div`
  background: rgba(233, 70, 0, 0.07);
  border-radius: 8px;
  padding: 8px 12px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: rgba(41, 46, 115, 0.82);
  margin-top: 20px;
`;

export const ChooseImageButton = styled(BaseButton)`
  width: 9.5rem;
  height: 2.75rem;
`;

export const ConfirmBtn = styled(PrimaryButton)`
  padding: 15px 30px;
`;

export const CenterColumn = styled(CommonFlexColumn)`
  align-items: center;
`;

export const PaymentSuccessModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 42px;
  }
`;

export const SuccessHash = styled.p`
  width: 100%;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 156%;
  text-align: center;
  color: rgba(41, 46, 115, 0.82);
  margin-bottom: 0;
`;

export const SuccessText = styled.h4`
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.02em;
  color: #080f6c;
  margin-bottom: 0;
`;
